import {useEffect, useState} from 'react';
import {createApiClient} from '../../shared/http/createApiClient.js';
import {selectSavedPage} from './pageSelection.js';
import LegacyPage from './legacy/LegacyPage.jsx';

const api = createApiClient({auth:true});
const readTab = () => new URLSearchParams(location.search).get('page_id') || new URLSearchParams(location.search).get('subtab') || 'social';
export default function CampaignPage({page, clientId}) {
  const [tab, setTab] = useState(readTab);
  const [data, setData] = useState(null), [error, setError] = useState(''), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const update = () => setTab(readTab());
    window.addEventListener('popstate', update);
    return () => window.removeEventListener('popstate', update);
  }, []);
  useEffect(() => {
    const controller = new AbortController(); setError('');
    api.get('/dashboard/paid-media/pages', {params:{client_id:clientId}, signal:controller.signal})
      .then(value => {if (!controller.signal.aborted) setData(value);})
      .catch(err => {if (!controller.signal.aborted) setError(err.message);});
    return () => controller.abort();
  }, [clientId, attempt]);
  const selected = data && selectSavedPage(data.pages, tab, data.social_page_id);
  useEffect(() => {
    if (!selected) return;
    const url = new URL(location.href); url.searchParams.delete('subtab'); url.searchParams.set('page_id', selected.id);
    history.replaceState(history.state, '', url.pathname + url.search);
  }, [selected?.id]);
  function navigate(id) {
    const url = new URL(window.location.href);
    url.searchParams.delete('subtab'); url.searchParams.set('page_id', id);
    window.history.pushState({}, '', url.pathname + url.search);
    setTab(id);
    window.dispatchEvent(new PopStateEvent('popstate'));
  }
  if (error) return <main className="o-page"><div className="o-state o-error" role="alert"><p>{error}</p><button className="o-btn" onClick={() => setAttempt(n => n + 1)}>Retry</button></div></main>;
  if (!data) return <main className="o-page"><p className="o-state" role="status">Loading dashboard pages…</p></main>;
  if (!selected) return <main className="o-page"><p className="o-state">No Paid Media pages are configured. Add a page in Dashboard Development → Pages Structure, then reload.</p><button className="o-btn" onClick={() => setAttempt(n => n + 1)}>Reload pages</button></main>;
  return <LegacyPage key={selected.id + ':' + data.revision} page={page} clientId={clientId}
    dashboardPage={selected} dashboardPages={data.pages} onCampaignTab={navigate} onRefreshPages={() => setAttempt(n => n + 1)}/>;
}
